import { capitalize } from "lodash";
import { IconStatus } from "../../constants";
import { format, parseISO } from "date-fns";

export const getBookingCategory = (bookingType) => capitalize(bookingType?.split("_")?.[0]) ?? bookingType ?? "";

export const getBookingDisplayText = (item) => {
  // Get the base category (Run, Action, etc.)
  const baseCategory = getBookingCategory(item?.type);

  // Check if it's an assisted run
  const isAssistedRun = baseCategory === "Run" &&
    item?.assistanceDeclaration?.requiresAssistance;

  // Return appropriate display text
  return isAssistedRun ? "Assisted Run" : baseCategory;
};

export const getBookingIconCategory = (item) => {
  if (!item) return {};

  const categoryName = getBookingDisplayText(item);

  return IconStatus.find((x) => x.text === categoryName) || {};
}

export const changeActionTypeToDisplay = (actionName) => {
  const actionNameList = actionName?.split("_") ?? [];
  actionNameList.shift();

  return actionNameList
    .map((word) => capitalize(word))
    .join(" ")
    .replace("Of", "of")
    .replace("Tests", "test(s)")
    .replace("Removal Disabling", "Removal/Disabling")
    .replace("Quality Support", "Quality/Support");
};

export const isActionType = (type) => !["Booking", "Reservation", "Run"].includes(type);

/**
 * Formats booking data for display in tooltips, with the correct booking type
 * @param {Object} booking - The booking object
 * @returns {Object} - Transformed booking object with tooltip and other display properties
 */
export const formatBookingForDisplay = (item) => {
  if (!item) return {};

  const displayItem = { ...item };

  try {
    displayItem.noEquipment = item?.bookedEquipments?.length || 0;
    displayItem.start = item?.dateFrom;
    displayItem.end = item?.dateTo;

    const displayCategory = getBookingDisplayText(item);
    const iconCategory = getBookingIconCategory(item);

    displayItem.color = iconCategory?.backgroundColor;
    displayItem.icon = iconCategory?.icon;
    displayItem.icon = iconCategory?.icon;
    displayItem.title = item?.type;

    // TODO: Handle new design based on category
    // Currently not used since legacy design is conflicting with new design
    // like .md-custom-event-wrapper { ... }
    // displayItem.cssClass = iconCategory?.cssClass;

    if (item?.dateFrom && item?.dateTo) {
      displayItem.tooltip = `${displayCategory} ${format(parseISO(item.dateFrom), "d-MMM h:mm aa")} to ${format(
        parseISO(item.dateTo),
        "d-MMM h:mm aa"
      )}`;
    } else {
      displayItem.tooltip = displayCategory || '';
    }
  } catch (error) {
    console.error('Error in formatBookingForDisplay:', error);
  }

  return displayItem;
};
